import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../Modal';
import { Button } from '../../Button';
import { Loader } from '../../Loader';
import { useMemory } from '../../../shared/use-memory';
import styles from './MemoryModal.css';

function MemoryModal({ isOpen, onCloseModal, chapter }) {
    const { memory, isLoading } = useMemory({ chapter, isOpen });

    if (!isOpen) {
        return null;
    }

    const paragraphs = memory?.content
        ? memory.content.split('\n\n').map((text) => text.trim()).filter(Boolean)
        : [];

    return (
        <Modal
            onCloseModal={onCloseModal}
            className={styles.modal}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    {!isLoading && <h2 className={styles.title}>{memory?.chapterTitle}</h2>}
                    <Button
                        iconLeft={{ name: 'close' }}
                        type='secondary'
                        onClick={onCloseModal}
                        size='small'
                        className={styles.closeButton}
                    />
                </div>
                {isLoading ? (
                    <div className={styles.loaderWrapper}>
                        <Loader variant='secondary' />
                    </div>
                ) : (
                    <article className={styles.memory}>
                        {paragraphs.map((text) => (
                            <p key={text} className={styles.paragraph}>{text}</p>
                        ))}
                    </article>
                )}
            </div>
        </Modal>
    );
}

MemoryModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    chapter: PropTypes.string
};

MemoryModal.defaultProps = {
    chapter: ''
};

export {
    MemoryModal
};
